<div class="modal-box-large">
    <div class="d-flex flex-column justify-content-start">
      <h4>Inserimento Nuovo Titolare</h4>
    </div>
      <div class="form-container">
        <h6 class="card-header-label" style="padding: 1em;">Dati generali</h6>
        <app-basic-form [form]="individualForm" [keys]="individualFormKeys"></app-basic-form>
        <h6 class="card-header-label" style="padding: 1em;">Indirizzo di nascita</h6>
        <app-basic-form [form]="birthForm" [keys]="birthFormKeys"></app-basic-form>
        <h6 class="card-header-label" style="padding: 1em;">Indirizzo di residenza</h6>
        <app-basic-form [form]="residenceForm" [keys]="residenceFormKeys"></app-basic-form>
      </div>
    <div class="d-flex justify-content-between mt-3">
      <button mat-raised-button [color]="'warn'" (click)="close()">Chiudi</button>
      <button mat-raised-button [color]="'primary'" [disabled]="isConfirmButtonDisabled" (click)="addNewSubject()">Conferma</button>
    </div>
</div>
